var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaperPlane = function SvgPaperPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.59.635a1.39 1.39 0 0 1 .858.122h.006l10.568 5.369a.968.968 0 0 1 .532.86v.008a.97.97 0 0 1-.531.865L2.449 13.238a1.39 1.39 0 0 1-1.827-1.925l.011-.018 2.633-4.3-2.633-4.3-.011-.019A1.39 1.39 0 0 1 1.591.63L1.59.635Zm10.095 5.8-9.73-4.686a.279.279 0 0 0-.397.216.282.282 0 0 0 .03.163l2.771 4.308 7.326-.001ZM4.331 7.547h7.359l-9.731 4.695a.279.279 0 0 1-.37-.379l2.742-4.316Z",
    fill: "#fff"
  })));
};
export default SvgPaperPlane;